import { Injectable } from '@angular/core';
import { ApiUrlConstant } from '@app-constants/api-url.constant';
import { RestApiService } from '@app-services/rest/rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class CommunicationMessageService extends RestApiService{
  apiUrl = ApiUrlConstant.apiUrl;
  singleRegistrationMessage(body:any) {
    const url = this.apiUrl + `/sms/singletestregistration`;
    return this.post<any>(url, body);
  }
  multiRegistrationMessage(body:any) {
    const url = this.apiUrl + `/sms/multipletestregistration`;
    return this.post<any>(url, body);
  }

  onTimeSubmissionMessage(body:any) {
    const url = this.apiUrl + `/sms/ontimetestsubmission`;
    return this.post<any>(url, body);
  }

  earlyTimeSubmissionMessage(body:any) {
    const url = this.apiUrl + `/sms/earlytestsubmission`;
    return this.post<any>(url, body);
  }

  multipleScoreTesregistration(body:any) {
    const url = this.apiUrl + `/sms/multiplescoretestregistration`;
    return this.post<any>(url, body);
  }

}
